export const GRID_SIZE = 13; // -6 to 6 = 13 cells
export const CELL_SIZE = 30; // pixels per cell
export const HORIZONTAL_PADDING = 40; // pixels
export const TOP_PADDING = 100; // pixels
export const DEFAULT_WALLPAPER_ID = 'LUMyOxVv';

/**
 * Convert grid coordinates (-6 to 6) to pixel position
 */
export const gridToPixel = (gridX: number, gridY: number) => {
    const x = gridX + 6;
    const y = 6 - gridY;

    const left = x * CELL_SIZE;
    const top  = y * CELL_SIZE + CELL_SIZE * (
          x <= (GRID_SIZE - 1) / 2   ? ((GRID_SIZE - 1) / 2 - x) / Math.pow(3, 0.5)
        /*x >  (GRID_SIZE - 1) / 2 */: (x - (GRID_SIZE - 1) / 2) / Math.pow(3, 0.5)
        // Isometric axis shift
    );

    return { left, top };
};
